import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeForm from "./stripeForm";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const { STRIPE_PK } = publicRuntimeConfig;
const stripePromise = loadStripe(STRIPE_PK);

const StripeCheckout = ({
  brand,
  plan,
  setCurrency,
  setCountryCode,
  onPaymentMethodSuccessful,
  defaultCurrency,
  countryCode,
  validateGame,
  customPrice,
}) => {
  return (
    <div className="paymentForm">
      <div className="columns is-mobile">
        <div className="column is-8">
          <h1 className="title">Secure Payment</h1>
        </div>
        <div className="column is-4">
          <img src="/stripe.png" width="100" className="is-pulled-right" />
        </div>
      </div>
      <Elements stripe={stripePromise}>
        <StripeForm
          brand={brand}
          customPrice={customPrice}
          plan={plan}
          setCountryCode={setCountryCode}
          setCurrency={setCurrency}
          countryCode={countryCode}
          defaultCurrency={defaultCurrency}
          onPaymentMethodSuccessful={onPaymentMethodSuccessful}
          validateGame={validateGame}
        />
      </Elements>
      <style jsx>{`
        .paymentForm {
          margin-bottom: 1em;
          max-width: 600px;
          margin: auto;
        }
      `}</style>
    </div>
  );
};

export default StripeCheckout;
